<template>
    <div>
        <PopupRemove
            v-model:visiblePopup="visiblePopup"
            :code="$route.meta.code"
            @goNext="goNext"
        />
        <!-- v-show="policyItem.name && isCardShow" -->
        <div
            ref="policyCard"
            :class="[isScrollOverCard ?'stickyTop' :'mt-1']"
        >
            <div class="rounded overflow-hidden mb-2.5">
                <div class="md:hidden bg-gray-800 h6 text-white py-[0.3125rem] pl-2.5">
                    {{ policyItem.fullPolicyNo }}
                </div>
                <div
                    class="bg-gray-700 h6 text-white flex justify-center justify-items-stretch divide-x divide-gray-400 py-[0.3125rem]"
                    :class="policyInvestment==='Y' ? 'grid grid-cols-3 md:grid-cols-4':'grid grid-cols-2 md:grid-cols-3'"
                >
                    <div class="text-center hidden md:block">
                        <div class="text-gray-200 text-xs shrink-0">
                            保單號碼
                        </div>
                        <div>{{ policyItem.fullPolicyNo|| '— —' }}</div>
                    </div>
                    <div class="text-center shrink-0">
                        <div class="text-gray-200 text-xs">
                            被保險人
                        </div>
                        <div class="w-[5.625rem] truncate mx-auto">
                            {{ policyItem.name|| '— —' }}
                        </div>
                    </div>
                    <div class="text-center shrink-0">
                        <div class="text-gray-200 text-xs">
                            商品幣別
                        </div>
                        <div>
                            {{ policyItem.currencyText|| '— —' }}
                        </div>
                    </div>
                    <div
                        v-if="policyInvestment==='Y'"
                        class="text-center shrink-0"
                    >
                        <div class="text-gray-200 text-xs">
                            投資屬性
                        </div>
                        <div>
                            {{ investTypeIQ }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 手機版 標題 -->
            <div class="flex justify-between items-start pb-2 md:hidden">
                <h3 v-if="tablist.length>1 && $route.meta.code">
                    {{ mobileIndex }}.
                </h3>
                <h3 class="flex-grow">
                    {{ title }}
                </h3>
                <button
                    v-if="tablist.length>1 && $route.meta.code && $route.meta.code!=='IQ'"
                    @click="openPopup"
                >
                    <SvgIcon
                        icon-name="delete_forever"
                        class="text-gray-400 w-[1.7rem] h-[1.7rem] xs:w-[1.875rem] xs:h-[1.875rem] cursor-pointer"
                    />
                </button>
            </div>
        </div>
        <div ref="contentPusher" />

        <div
            v-show="isTabsShow"
            class="hidden md:block"
        >
            <div
                ref="scrollDom"
                class="w-full relative flex whitespace-nowrap overflow-hidden "
            >
                <tabs class="tabs flex-nowrap pr-16">
                    <!-- v-for="(item, i) in tablist" -->
                    <tab
                        v-for="(item, i) in tablist"
                        :key="i"
                        class="tab mr-1"
                        :class="{active:item.transactionItemNo === $route.meta.code}"
                        :val="item.transactionItemNo"
                        :indicator="true"
                    >
                        <div>
                            {{ item.transactionItemName }}
                        </div>
                        <button
                            v-if="item.transactionItemNo === $route.meta.code && tablist.length !==1 && $route.meta.code!=='IQ' && !item.forceSelect"
                            class="cursor-pointer ml-4"
                            @click="openPopup"
                        >
                            <SvgIcon
                                icon-name="delete_forever"
                                class="text-gray-700 w-[1.875rem] h-[1.875rem] cursor-pointer"
                            />
                        </button>
                    </tab>
                </tabs>
            </div>
        </div>
        <ButtonNextService v-model:isSubmitOk="isSubmitOk">
            <span />
        </ButtonNextService>
    </div>
</template>

<script>
import { onMounted, ref, computed, watch, onBeforeUnmount, nextTick } from 'vue';
import { useEventListener } from '@vueuse/core';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { Tabs, Tab } from 'vue3-tabs';
import PopupRemove from '@/components/dialogs/PopupRemove.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import BScroll from '@better-scroll/core';
import Scrollbar from '@better-scroll/scroll-bar';
import MouseWheel from '@better-scroll/mouse-wheel';
import { makeSort } from '@/utils/array/makeSort';
import { EUDC } from '@/utils/EUDC';
BScroll.use(Scrollbar);
BScroll.use(MouseWheel);
export default {
    name: 'StickyTopPolicyCard',
    components: {
        PopupRemove, Tabs, Tab, ButtonNextService
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const policyCard = ref(null);
        const contentPusher = ref(null);
        const scrollDom = ref(null);
        const scroll = ref(null);
        const isSubmitOk = ref(false);
        const isScrollOverCard = ref(false);
        const windowWidth = ref(window.innerWidth);
        const policyCardOffsetTop = ref(null);
        const title = ref('');
        const visiblePopup = ref(false);
        const isTabsShow = ref(false);
        EUDC();
        const allItems = computed(() => makeSort(store.state.services.transactionItems, 'transactionItemOrder'));
        const tablist = computed(() => {
            const list = allItems.value.filter(i => i.userChecked) || [];
            return list;
        });
        const mobileIndex = computed(() => {
            const list = store.state.services.serviceList;
            const index = list.findIndex(i => i.transactionItemNo === route.meta.code);
            return index + 1;
        });
        const openPopup = () => {
            visiblePopup.value = true;
        };

        const policyItem = computed(() => store.state.policy.policy);
        const policyInvestment = computed(() => store.state.policy.policyKindInvestment);

        // 投資屬性問卷的投資型態顯示以最新的問卷型態為主
        // const investTypeIQ = ref(store.state.changeItemsResult?.IQ || policyItem.value.investTypeText || '— —');
        const investTypeIQ = computed(() =>
            store.state.services.changeItemsResult?.IQ || policyItem.value.investTypeText || '— —'
        );

        /** 判斷最後一步是去CONFIRM_DATA or RISK_NOTICE */
        const goNext = () => {
            isSubmitOk.value = true;
        };
        onMounted(() => {
            scroll.value = new BScroll(scrollDom.value, {
                scrollX: true,
                scrollY: false,
                click: true,
                mouseWheel: true,
                bounce: false,
                resizePolling: 60,
                probeType: 1,
                disableMouse: false,
                disableTouch: false,
                scrollbar: {
                    fade: true,
                    interactive: true,
                    scrollbarTrackClickable: false,
                }
            });
            policyCardOffsetTop.value = policyCard.value.offsetTop;

            useEventListener(window, 'resize', (evt) => {
                windowWidth.value = window.innerWidth;
                if (!isScrollOverCard.value) {
                    policyCardOffsetTop.value = policyCard.value.offsetTop;
                }
                if (windowWidth.value > 780) {
                    isScrollOverCard.value = false;
                    contentPusher.value.style.height = null;
                }
            });

            useEventListener(window, 'scroll', (evt) => {
                if (windowWidth.value < 780) {
                    const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                    if (scrollTop > policyCardOffsetTop.value) {
                        const policyCardHeight = policyCard.value.clientHeight;
                        isScrollOverCard.value = true;
                        contentPusher.value.style.height = policyCardHeight + 'px';
                    } else {
                        isScrollOverCard.value = false;
                        contentPusher.value.style.height = null;
                    }
                }
            });
        });
        onBeforeUnmount(() => {
            scroll.value.destroy();
        });

        const setTitle = (code) => {
            if (!code) {
                title.value = route.meta.pageTitle;
            } else {
                const obj = tablist.value.find(i => i.transactionItemNo === code);
                title.value = obj.transactionItemName;
            }
        };
        watch(() => route.meta.code, (nV, oV) => {
            if (nV === oV) {
                return;
            }
            const { code } = route.meta;
            let index = null;
            if (code && tablist.value.length > 0) {
                index = tablist.value.findIndex(i => i.transactionItemNo === code);
                if (index !== -1) {
                    isTabsShow.value = true;
                }
                // 滾動到下一個 tab
                nextTick(() => {
                    scroll.value.scrollToElement(document.querySelector('div.tab.active'), 300, -64);
                });
            } else {
                isTabsShow.value = false;
            }
            setTitle(code);
        }, { immediate: true });
        watch(() => route.meta.pageTitle, () => {
            if (!route.meta.code) {
                setTitle();
            }
        }, { immediate: true });

        return {
            policyCard,
            contentPusher,
            isScrollOverCard,
            policyItem,
            investTypeIQ,
            tablist,
            policyInvestment,
            isTabsShow,
            visiblePopup,
            openPopup,
            title,
            goNext,
            scrollDom,
            scroll,
            mobileIndex,
            isSubmitOk
        };
    }
};
</script>

<style  lang="scss" scoped>
.stickyTop {
    @apply fixed top-0 left-0 right-0 bg-white z-[51] shadow-1 pt-2.5 px-3 xs:px-5;
}

.pageFade-enter-active,
.pageFade-leave-active {
    transition: opacity 0.4s ease;
}

.pageFade-enter-from,
.pageFade-leave-to {
    opacity: 0;
}
.tabs :deep(.tab) {
    @apply bg-gray-75 p-0 py-1 rounded-t-lg flex-shrink-0 text-[1.3125rem] md:px-4 lg:px-7 text-gray-200 cursor-default;
    height: fit-content;

    &:not(.active) div {
        @apply w-16 truncate;
    }
    &.active {
        @apply bg-white border-b-0 md:px-5 lg:px-7 pb-1 pt-3.5 rounded-t-lg text-[1.3125rem]  text-gray-900 font-bold cursor-default;
    }
}
</style>
